import React from 'react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { OpeningStatement } from '../components/OpeningStatement';
import { AccessFallacy } from '../components/AccessFallacy';
import { LogoScroll } from '../components/LogoScroll';
import { GeneticAI } from '../components/GeneticAI';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2358">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2359">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2360">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2361">
            <Link to="/" data-id="element-2362">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2363" />
            </Link>
            <Navigation data-id="element-2364" />
          </div>
        </div>
      </header>

      <main data-id="element-2365">
        <Hero data-id="element-2366" />
        <OpeningStatement data-id="element-2367" />
        <AccessFallacy data-id="element-2368" />
        <LogoScroll data-id="element-2369" />
        <GeneticAI data-id="element-2370" />
        <CTASection data-id="element-2371" />
      </main>

      <Footer data-id="element-2372" />
    </div>;
}